import { FaEthereum } from 'react-icons/fa'
import CryptoTicker from '../CryptoTicker'

const Ethereum = (): JSX.Element => (
  <CryptoTicker
    coinId="ethereum"
    title="Ethereum"
    subtitle="Smart Contract Platform"
    icon={FaEthereum}
  />
)

export default Ethereum
